import React from "react";
import { Link } from "react-router-dom";

const getPosterUrl = (path) => {
    return `https://www.themoviedb.org/t/p/w220_and_h330_face${path}`;
}

function MovieCard({ movie }) {
    // getPosterUrl(poster_path)
    // console.log(movie)

    return (
        <div className="flex flex-col pl-5 gap-2 transform transition duration-500 hover:scale-110">
            <Link to={`/movie/${movie.id}`}>
            <img src={getPosterUrl(movie?.poster_path)} className="w-[150px] h-[225px] shadow-sm rounded-md"  />

            <div className="flex flex-col w-[150px] px-3">
                <h4 className="font-bold">{movie?.name || movie?.title}</h4>
            </div>
            </Link>
        </div>
    );
}

export default MovieCard;
